import { CountriesEnum, RegionsEnum } from '../generated/operations';

export const getDefaultCountry = (region: RegionsEnum): CountriesEnum => {
  switch(region) {
    case RegionsEnum.Ap:
      return CountriesEnum.Hk;
    case RegionsEnum.Am:
      return CountriesEnum.Us;
    case RegionsEnum.Eu:
    default:
      return CountriesEnum.Ch;
  }
}
